import React from 'react';
import Dialog from 'ui/views/dialogs/Dialog';
import { KpiWithDisplay } from 'domain/kpis/types';
import KpiEditModalContent from './KpiEditModalContent';

interface KpiEditModalProps {
  kpi: KpiWithDisplay;
  companyId: number;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function KpiEditModal({ kpi, companyId, isOpen, onClose, onSuccess }: KpiEditModalProps) {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="lg" mobileLayout="fullscreen">
      {isOpen && <KpiEditModalContent kpi={kpi} companyId={companyId} onClose={onClose} onSuccess={onSuccess} />}
    </Dialog>
  );
}
